import * as S from './styles';

export type LoadingStateProps = {
  children: React.ReactNode;
};

const LoadingState = ({ children }: LoadingStateProps) => (
  <S.Wrapper>
    <S.Spinner size={32} />
    <S.Content>{children}</S.Content>
  </S.Wrapper>
);

export default LoadingState;
